import React from 'react';
import { Container } from 'react-bootstrap';
import { FileImport } from '../../components/common/FileImport';
import { produtosImportService } from '../../services/importService';

export const ProdutosImportPage: React.FC = () => {
  return (
    <Container fluid className="py-4">
      <FileImport
        tipo="produtos"
        title="Importação de Produtos"
        description="Importe produtos em lote através de arquivos CSV ou Excel. O arquivo deve conter as colunas: codigo, descricao, tipo, categoria_produto, unidade, etc."
        onImport={produtosImportService.import}
        templateUrl="/templates/Lista de Produtos.xlsx"
      />
    </Container>
  );
};
